import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from "../../assets/img/logo_20250311.png";
import logo2x from "../../assets/img/logo_20250311@2x.png";

const Header = ({ 
    title, 
    logoDirection="col", //col | row 
    customStyle="",
    hasLogoInDesktop=false,
    hasBorderBottom=true
}: any) => {
    const location = useLocation();
    const navigate = useNavigate();
    const showButton = ["/ResetPassword", "/ResetPassword2", "/ResetPassword3"].includes(location.pathname);
    return (
        <header>
            <div className={`md:p-0 p-4 pb-0 md:border-b-0 ${hasBorderBottom ? "border-b border-[#E0E0E0]" : ""} relative`}>
                {showButton && (
                    <button onClick={() => navigate(-1)} className='w-6 h-6 lg:hidden absolute left-4 alu-text-base-1 rounded focus:bg-[#EA6D00] focus:text-white'
                    title='戻る'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18L15.4102 16.59Z" className='fill-current' />
                        </svg>
                    </button>
                )}
                <div className={`flex items-center justify-center ${logoDirection === "row" ? "flex-row" : "flex-col"} gap-2 ${customStyle}`}>
                    <span className={`${!hasLogoInDesktop ? "md:hidden" : ""}`}>
                        <img src={logo}
                            srcSet={`${logo} 1x, ${logo2x} 2x`}
                            alt="aloop logo" 
                            width="103" 
                            height="27"
                        />
                    </span>
                    <h2 className="text-xl font-bold alu-text-base-2">{title}</h2>
                </div>
            </div>
        </header>
    );
};

export default Header;
